import { render, staticRenderFns } from "./BlockEditorDraggablePrefix.vue?vue&type=template&id=0ad72cdd"
import script from "./BlockEditorDraggablePrefix.vue?vue&type=script&lang=js"
export * from "./BlockEditorDraggablePrefix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports